import { render } from "./BoldAction.vue?vue&type=template&id=5962cef6"
import script from "./BoldAction.vue?vue&type=script&lang=js"
export * from "./BoldAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__